export default apiFetch => async payload => {
  const response = await apiFetch({
    endpoint: "request-copy",
    method: "post",
    body: payload
  });

  return await response.json();
};
